'use client';

import CategoryPage from '@/joystagram-components/components/consumer/CategoryPage';
import WarehouseIdHydrator from '@/joystagram-components/global-state/warehouseIdForUser/WarehouseIdHydrator';

export default function CategoryPageClient({
  serverCategoryData,
  serverWarehouseId,
  algoliaUserToken,
}) {
  return (
    <WarehouseIdHydrator warehouseId={serverWarehouseId}>
      <CategoryPage
        serverCategoryData={serverCategoryData}
        algoliaUserToken={algoliaUserToken}
      />
    </WarehouseIdHydrator>
  );
}
